import React from 'react';
import { Route } from 'src/navigation/Route';
import { AdminScreen } from './screens/Admin';
import { UserType } from 'src/model/UserType';

export const ADMIN_ROUTES = {
  itself: '/admin',
  onParams: '/admin/:id',
};

export const AdminNavigation = (): JSX.Element => (
  <>
    <Route
      exact
      path={ADMIN_ROUTES.itself}
      component={AdminScreen}
      isPrivateRoute
      allowedTypes={[UserType.ADMIN]}
    />
    <Route
      exact
      path={ADMIN_ROUTES.onParams}
      component={AdminScreen}
      isPrivateRoute
      allowedTypes={[UserType.ADMIN]}
    />
  </>
);
